"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EnsAvatarUnsupportedNamespaceError = exports.EnsAvatarUriResolutionError = exports.EnsAvatarInvalidNftUriError = exports.EnsAvatarInvalidMetadataError = void 0;
const base_js_1 = require("./base.js");
class EnsAvatarInvalidMetadataError extends base_js_1.BaseError {
  constructor(_ref) {
    let {
      data
    } = _ref;
    super('Unable to extract image from metadata. The metadata may be malformed or invalid.', {
      metaMessages: ['- Metadata must be a JSON object with at least an `image`, `image_url` or `image_data` property.', '', "Provided data: ".concat(JSON.stringify(data))]
    });
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'EnsAvatarInvalidMetadataError'
    });
  }
}
exports.EnsAvatarInvalidMetadataError = EnsAvatarInvalidMetadataError;
class EnsAvatarInvalidNftUriError extends base_js_1.BaseError {
  constructor(_ref2) {
    let {
      reason
    } = _ref2;
    super("ENS NFT avatar URI is invalid. ".concat(reason));
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'EnsAvatarInvalidNftUriError'
    });
  }
}
exports.EnsAvatarInvalidNftUriError = EnsAvatarInvalidNftUriError;
class EnsAvatarUriResolutionError extends base_js_1.BaseError {
  constructor(_ref3) {
    let {
      uri
    } = _ref3;
    super("Unable to resolve ENS avatar URI \"".concat(uri, "\". The URI may be malformed, invalid, or does not respond with a valid image."));
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'EnsAvatarUriResolutionError'
    });
  }
}
exports.EnsAvatarUriResolutionError = EnsAvatarUriResolutionError;
class EnsAvatarUnsupportedNamespaceError extends base_js_1.BaseError {
  constructor(_ref4) {
    let {
      namespace
    } = _ref4;
    super("ENS NFT avatar namespace \"".concat(namespace, "\" is not supported. Must be \"erc721\" or \"erc1155\"."));
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'EnsAvatarUnsupportedNamespaceError'
    });
  }
}
exports.EnsAvatarUnsupportedNamespaceError = EnsAvatarUnsupportedNamespaceError;
//# sourceMappingURL=ens.js.map